module.exports = __webpack_public_path__ + "static/media/radiantSweet.0742aa69.gif";